import { Hub, IConnection } from "@gp/hub";
import { BetBoosterHubOptions } from "./BetBoosterHubOptions";
import { Observable } from "rxjs";
import { ArgumentNullError } from "@gp/utility";
import { Filter } from "@api-types/bet-booster/BetBoosterHubFilter";
import { BetBoosterHubResponse } from "@api-types/bet-booster/BetBoosterHubResponse";

export class BetBoosterHub extends Hub {
	constructor(options: BetBoosterHubOptions, connection: IConnection) {
		super(options, connection);

		this.initialize();
	}

	getSubscription(request: Filter): Observable<BetBoosterHubResponse> {
		if (request == null) {
			throw new ArgumentNullError("request");
		}

		return this.createSubscription(
			request.subscriptionId,
			() => {
				return this.invoke("Subscribe", request);
			},
			() =>
				this.invoke("Unsubscribe", {
					subscriptionId: request.subscriptionId,
				})
		);
	}
}
